import './StandardCalendarDate.scss';
import { useState, useEffect } from 'react';
import OtherEvent from '../../StandardCalendarEvent/OtherEvent/OtherEvent';
import PairingEvent from '../../StandardCalendarEvent/PairingEvent/PairingEvent';
import { isWeekend } from './../StandardCalendarHelper';
import { eventActivityType } from '../../../constants/myBlockMonth';
import { convertToDateObject, convertToDateTime } from '../../../helpers/dateHelpers';
import { useMyBlockMonthProvider } from '../../../providers/MyBlockMonthProvider';

const StandardCalendarDate = ({ actualView, checked, day, holidayEventList, noData, document, key}) => {
  const myBlockMonthContext = useMyBlockMonthProvider();
  const [activityHoliday, setActivityHoliday] = useState('');
  const [width, setWidth] = useState(0);
  const dateNumber = convertToDateObject(day.day, '00:00').getDate();

  const getDateClassName = (day) => {
    const className = 'standard-calendar__date';
    let classNameAdd = 'standard-calendar__date';
    if(day.events.length > 0) {
      if(day.events.some(event => event.activityType === eventActivityType.PAIRING || event.activityType === eventActivityType.TRAINING || event.activityType === eventActivityType.RAP || event.activityType === eventActivityType.RAPH || event.activityType === eventActivityType.ITC)) {
        classNameAdd = `${classNameAdd} ${className}--blue-bg`; 
      }
    }
    if(isWeekend(day.day)) classNameAdd = `${classNameAdd} ${className}--weekend`;
    return classNameAdd;
  }

  const getDateNumberClassName = (day) => {
    const className = 'date__num';
    if(day.isToday) return `${className} ${className}--today`;
    if(isNotBlockDate(day.day)) return `${className} ${className}--carryover`;
    if(day.events.length > 0) {
      if(day.events.some(event => event.activityType === eventActivityType.PAIRING || event.activityType === eventActivityType.TRAINING || event.activityType === eventActivityType.RAP || event.activityType === eventActivityType.RAPH || event.activityType === eventActivityType.ITC)) {
        return `${className} ${className}--blue`;
      }
    }
    return className;
  }
  
  const getEventsBasedOnType = (event) => {
    if(event.activityType === eventActivityType.PAIRING ) { 
      const startDate = event.hasStartRelease && !event.carryIn ? event.release[0].start_date : event.start_date;
      if(startDate === day.day) {
        return (
          <PairingEvent
            actualView={actualView}
            event={event}
            width={width-2}
          />
        );
      }
    } else {
      const startDate = event.hasStartRelease && event.release[0].start_date === day.day ? event.release[0].start_date : event.start_date;
      if(startDate === day.day) {
        return (<OtherEvent actualView={actualView} event={event}/>);
      }
    }
  }

  /**
   * @param day 
   * @returns true if the day is not within (inclusive) the block date 
   */
  const isNotBlockDate = (day) => {
    const blockDate = {
      start: convertToDateTime(myBlockMonthContext.myBlockMonthData.blockDates?.start, '00:00'),
      end: convertToDateTime(myBlockMonthContext.myBlockMonthData.blockDates?.end, '23:59')
  }
    const eventDate = convertToDateTime(day, '00:00');
    if(eventDate < blockDate.start || eventDate > blockDate.end) return true;
    return false;
  }

  const setDayWidth = () => {
    const dayContainer = document.getElementsByClassName('standard-calendar__date')[0];
    if(dayContainer) setWidth(dayContainer.getBoundingClientRect().width + 1);
  }

  const getHolidayEvent = (day) => {
    if(holidayEventList && holidayEventList.length ){
      for(const event of holidayEventList){
        if(day.day === event.start_date) {
          setActivityHoliday(event.remarks.length > 32 ? event.remarks.slice(0,32)+'...' :event.remarks);
          break;
        }
      }
    }    
  }

  useEffect(()=> {
    setDayWidth();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actualView]);

  useEffect(()=>{    
    getHolidayEvent(day);
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[day]);

  window.addEventListener('resize', setDayWidth)

  const getHolidayEventHeight = (width: string) => {
    const num = Number(width.replace('rem',''));
    return `${num-3}rem`;
  }

  const getOverlayClassName = (day) => {
    if(day.events.length > 0) {
      if(day.events.some(event => event.activityType === eventActivityType.PAIRING || event.activityType === eventActivityType.TRAINING || event.activityType === eventActivityType.RAP || event.activityType === eventActivityType.RAPH || event.activityType === eventActivityType.ITC)) {
        return ' standard-calendar__date--not-a-block-date standard-calendar__date--blue-bg';
      }
    }
    return 'standard-calendar__date--not-a-block-date';
  }

  return (
    <div className={getDateClassName(day)} style={{minHeight: day.height}} id={'day-'+day.day} key={key}>
      {isNotBlockDate(day.day) && <div className={getOverlayClassName(day)} />}
      <div className="date__header">
        <span className={getDateNumberClassName(day)}>{dateNumber}</span>
        <span className="date__today-lbl">{day.isToday ? 'Today' : ''}</span>
      </div>      
      {!noData && width > 0 && day.events.map(event => { return(getEventsBasedOnType(event)) }) }
      {!noData && checked && (
        <div className="c-date__holiday" style={{minHeight: getHolidayEventHeight(day.height)}}>
            <span className="holiday__label">{activityHoliday}</span>
        </div>
      )}
    </div>
  );
}

export default StandardCalendarDate;